export const ru = {
    'are-you-sure-to-reject': 'Вы уверены, что хотите отклонить сделку?',
    'are-you-sure-to-reject-deal-and-save-title':
        'Вы уверены, что хотите сохранить название и отклонить сделку?',
    'deistvie-ne-mojet-bit-otmeneno': 'Действие не может быть отменено',
    'request-error': 'Произошла ошибка. Попробуйте еще раз.'
};
